// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__Agttw","avatar__img":"Avatar_avatar__img__pF2J5"};